import React from 'react';
import './AccountingHome.css';

// Icons
const PurchaseOrdersIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <rect x="6" y="8" width="36" height="32" rx="4" fill="#4CAF50" />
    <rect x="12" y="16" width="24" height="3" rx="1.5" fill="white" />
    <rect x="12" y="23" width="18" height="3" rx="1.5" fill="white" />
    <rect x="12" y="30" width="20" height="3" rx="1.5" fill="white" />
    <circle cx="38" cy="36" r="8" fill="#2E7D32" />
    <path d="M35 36h6M38 33v6" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const InvoicesIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <rect x="8" y="4" width="32" height="40" rx="3" fill="#2196F3" />
    <rect x="14" y="12" width="20" height="2" fill="white" />
    <rect x="14" y="18" width="16" height="2" fill="white" />
    <rect x="14" y="24" width="18" height="2" fill="white" />
    <rect x="14" y="30" width="12" height="2" fill="white" />
    <path d="M14 38h10" stroke="white" strokeWidth="2" />
    <path d="M28 38h6" stroke="white" strokeWidth="2" />
    <circle cx="36" cy="10" r="6" fill="#1565C0" />
    <text x="36" y="13" textAnchor="middle" fontSize="8" fill="white" fontWeight="bold">$</text>
  </svg>
);

const ExpensesIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <rect x="4" y="12" width="40" height="28" rx="4" fill="#FF5722" />
    <rect x="4" y="18" width="40" height="8" fill="#E64A19" />
    <circle cx="24" cy="32" r="6" fill="#FFCC80" />
    <text x="24" y="35" textAnchor="middle" fontSize="8" fill="#E64A19" fontWeight="bold">$</text>
    <rect x="10" y="8" width="28" height="4" rx="2" fill="#BF360C" />
  </svg>
);

const accountingCards = [
  {
    id: 'purchase-orders',
    name: 'Purchase Orders',
    icon: PurchaseOrdersIcon,
    count: 12,
    color: '#4CAF50',
    bgColor: '#E8F5E9'
  },
  {
    id: 'invoices',
    name: 'Invoices',
    icon: InvoicesIcon,
    count: 28,
    color: '#2196F3',
    bgColor: '#E3F2FD'
  },
  {
    id: 'expenses',
    name: 'Expenses',
    icon: ExpensesIcon,
    count: 45,
    color: '#FF5722',
    bgColor: '#FBE9E7'
  }
];

const AccountingHome = ({ onCardClick }) => {
  const handleCardClick = (cardId) => {
    if (onCardClick) {
      onCardClick(cardId);
    }
  };

  return (
    <div className="accounting-home">
      {/* Header */}
      <div className="accounting-header">
        <h1>Accounting</h1>
        <p>Manage your financial operations</p>
      </div>

      {/* Cards Grid */}
      <div className="accounting-cards-grid">
        {accountingCards.map((card) => {
          const IconComponent = card.icon;
          return (
            <button
              key={card.id}
              className="accounting-card"
              onClick={() => handleCardClick(card.id)}
              style={{ '--card-color': card.color, '--card-bg': card.bgColor }}
            >
              <div className="accounting-card-icon">
                <IconComponent />
              </div>
              <div className="accounting-card-info">
                <h3 className="accounting-card-name">{card.name}</h3>
                <span className="accounting-card-count">{card.count} Items</span>
              </div>
              <div className="accounting-card-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </div>
            </button>
          );
        })}
      </div>

      {/* Quick Stats */}
      <div className="accounting-stats">
        <div className="stat-card">
          <span className="stat-label">Total Pending</span>
          <span className="stat-value pending">₹ 2,45,000</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Total Paid</span>
          <span className="stat-value paid">₹ 8,75,500</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">This Month</span>
          <span className="stat-value month">₹ 1,25,000</span>
        </div>
      </div>
    </div>
  );
};

export default AccountingHome;

